export const AddressZero = '0x0000000000000000000000000000000000000000';
export const AlternativeAddressZero = '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee';
export const SolSystemProgram = '11111111111111111111111111111111';
export const MaxUint48 = BigInt('0xffffffffffff');
export const MaxUint160 = BigInt('0xffffffffffffffffffffffffffffffffffffffff');
export const MaxUint256 = BigInt(0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffn);
//# sourceMappingURL=constants.js.map